/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { ConcernsIssueTypeDto } from './concernsIssueTypeDto.schema';

export const IReadOnlyListOfConcernsIssueTypeDto = zod.array(zod.lazy(() => ConcernsIssueTypeDto));

export type IReadOnlyListOfConcernsIssueTypeDto = zod.input<typeof IReadOnlyListOfConcernsIssueTypeDto>;
export type IReadOnlyListOfConcernsIssueTypeDtoOutput = zod.output<typeof IReadOnlyListOfConcernsIssueTypeDto>;
